<template>
  <div class=" pro-lst">
    <div class="gimg">
      <van-image
        width="100"
        height="100"
        :src="_getPic(goods.Logo, true)"
      />
      <!-- 类型icon -->
      <div class="type-icon">
        <div v-if="!type" />
        <div v-else-if=" iconType.includes(type)">
          <div :class="['icon-lt','icon-lt-'+type]">
            <img :src="require(`@/assets/buycar/type-${type}.png`)" alt="">
          </div>
          <div v-if="type=== 5 && goods.ActivityDiscount" :class="['icon-tj']">{{ goods.ActivityDiscount }} 折</div>
        </div>

        <div
          v-else
          :class="
            ['icon-bt','icon-bt-'+type]"
          :style="{'color':txtColorType.includes(type)?'#ffffff':'#111A34 ','backgroundImage':'url('+require(`@/assets/buycar/type-${type}.png`)+')'}"
        >
          <div>{{ goods.ActivityRule }}</div>
        </div>
      </div>
      <div v-if="giftType === 2" class="mask">换购</div>
      <div v-if="giftType === 1" class="mask">赠品</div>
      <!-- <div v-if="activityCode === 3" class="mask">满赠</div> -->
    </div>

    <div class="pro-content">
      <div class="gname">
        <!-- 新品标签 -->
        <img v-if="goods.IsNewProduct" style="width: 30px;" src="@/assets/goods/new.png">
        <!-- <span class="tag-name" v-if="goods.Tags && goods.Tags.length">{{goods.Tags[0]}}</span> -->
        <div class="name-title ellips-text">
          {{ _showProductTitle(goods.SkuName, goods.OperationName) }}
        </div>
      </div>
      <div class="gsize">
        规格：{{ goods.SpecificationsName || goods.Specifications }}/{{ goods.Unit }}
      </div>
      <div v-if="goods.Validity" class="gsize">
        效期：{{ goods.Validity }}
      </div>
      <div
        class="gtag"
        style="margin-top: 12px; color: #999999;"
      >
        最低零售价 ￥{{ goods.RetailPrice ? goods.RetailPrice.toFixed(2) : '-' }}
        | 毛利率
        {{
          _showProductProfit(
            goods.RetailPrice,
            _getProductPrice(goods.ActivityPrice || '', goods.PriceLimit || '')
          )
        }}%
      </div>
      <div v-if="giftType==0" class="tag-list">
        <div v-for="(val,idx) in goodsTagList" :key="idx" :class="['tag-box','tag-type-'+val.type]">{{ val.txt }}</div>

      </div>
    </div>
    <div class=" price-content">
      <div class="pro-col">

        <template v-if="goods.ActivityCode">
          <b
            v-if="goods.ActivityPrice"
            class="price activePrice"
          > {{ type===8?'秒杀':'优惠价' }} <i>￥{{ goods.PriceLimit ||0 }}</i>
          </b>

          <p v-else class="price">￥{{ goods.PriceLimit }}</p>
          <s v-if="goods.ActivityPrice && goods.ActivityCode">￥{{ _moneyFormat(goods.Price) }}</s>
        </template>
        <template v-else-if="giftType==1">
          <b

            class="price activePrice"
          >优惠价<i>￥{{ 0 }}</i>
          </b>

          <s>￥{{ _moneyFormat(goods.Price) }}</s>
        </template>
        <template v-else>
          <b
            v-if="goods.PriceLimit<goods.Price"
            class="price activePrice"
          >优惠价<i>￥{{ goods.PriceLimit }}</i>
          </b>

          <p v-else class="price">￥{{ goods.PriceLimit||0 }}</p>
          <s v-if="goods.PriceLimit<goods.Price">￥{{ _moneyFormat(goods.Price) }}</s>
        </template>
      </div>
    </div>
    <!-- 数量 -->
    <div class="pro-col">
      {{ goods.Count }}
    </div>

    <div class="pro-col">
      ￥{{ _moneyFormat(goods.Price * goods.Count) }}
    </div>
    <div class="pro-col pro-total">
      ￥{{ _moneyFormat(goods.TotalCount) }}
    </div>

  </div>
</template>

<script>
import { BaseMixin } from '@/mixins/BaseMixin'
import moment from 'moment'
export default {
  name: 'ProductDetails',
  mixins: [BaseMixin],
  props: {
    goods: {
      type: Object,
      default: () => {}
    },
    type: {
      type: Number,
      default: () => 0
    },
    // 1 赠品,2换购
    giftType: {
      type: Number,
      default: () => 0
    }

  },
  data() {
    return {
      typeList: [
        { val: 5, label: '特价' },
        { val: 6, label: '满减' },
        { val: 3, label: '满赠' },
        { val: 7, label: '满返' },
        { val: 4, label: '换购' },
        { val: 8, label: '秒杀' },
        { val: 9, label: '效期' }
      ],
      goodsTagList: [
      ],
      // 特殊位置得标签 活动类型标记 右上角位置展示icon
      iconType: [8, 5, 9],
      // 下方字体颜色
      txtColorType: [4, 3],
      showInputNum: false,
      valInputNum: 0,
      edited: false,
      ruleTxt: ''
    }
  },
  computed: {
  },
  watch: {
    goods: {
      handler(val) {
        if (val) {
          this.goodsTagList = []
          val.ActivityCode ? this.goodsTagList.push({ type: 1, txt: this.getConfigType(val.ActivityCode) }) : null
          val.MedicalType ? this.goodsTagList.push({ type: 2, txt: val.MedicalType == 1 ? '甲类' : val.MedicalType == 2 ? '乙类' : '医保' }) : null
          val.CountryCode ? this.goodsTagList.push({ type: 3, txt: '国家码' }) : null
        }
      },
      deep: true,
      immediate: true
    }
  },

  mounted() {},
  methods: {
    moment,
    // 获取对应字典内容
    getConfigType(data) {
      const dataArr = this.typeList.filter(v => v.val === data)
      return dataArr.length ? dataArr[0].label : ''
    },
    // 跳转商品详情
    cleckItem(item) {
      const { isInvalid } = this
      if (isInvalid) {
        return
      }
      this._jump(this._getTurnUrl(12), item.GoodSkuId)
    },

    // 获取商品实际价格
    _getProductPrice(price1, price2) {
      if (!price1 && !price2) {
        return 0
      }
      let price = price2
      if (price1 && price1 <= price2) {
        price = price1
      }
      return price
    }
  }
}
</script>

<style lang="less" scoped>
  .pro-lst {
    position: relative;
    display: flex;
    border-bottom: 2px rgba(224, 224, 224, .3) solid;
    padding: 30px 0 30px 20px;
    text-align: left;
    box-sizing: border-box;

    .img-overlay,
    span {
      position: absolute;
      bottom: 30px;
      left: 20px;
      width: 100px;
      height: 25px;
      font-size: 14px;
      text-align: center;
      color: #FFFFFF;
      line-height: 25px;
    }

    .img-overlay {
      background-color: #FF3939;
      opacity: .6;
    }

    .pro-content {
      padding-left: 25px;
      width: 355px;

      .gname {
        font-size: 14px;
        font-weight: 400;
        text-align: left;
        color: #222222;
      }

      .gsize {
        margin-top: 10px;
        font-size: 12px;
        font-weight: 400;
        text-align: left;
        color: #777777;
      }

      .name-title {
        flex: 1;
      }
    }

    .pro-col {
      width: 145px;
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      color: #222222;
    }

    .pro-total {
      font-weight: 600;
      color: #FF3939;
    }

    &:last-child {
      border: none;
    }
  }

  .gimg {
    position: relative;
    margin-left: 20px;
    cursor: pointer;

    /deep/ img {
      background: rgba(243, 245, 248, 1);
    }

    .mask-error {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      border-radius: 50%;
      width: 100px;
      height: 100px;
      font-size: 16px;
      color: #FFFFFF;
      background: #111A34;
      opacity: .65;
      line-height: 100px;
    }
    // 右上方图片
    .icon-lt {
      position: absolute;
      top: 0;
      left: 0;
    }

    .icon-lt-8 {
      img {
        width: 34px;
        height: 34px;
      }
    }

    .icon-lt-5 {
      padding: 2px 0 0 2px;

      img {
        width: 40px;
        height: 32px;
      }
    }

    .icon-lt-9 {
      img {
        width: 46px;
        height: 46px;
      }
    }

    .type-icon {
      img {
        background-color: unset;
      }
    }

    .icon-tj {
      position: absolute;
      bottom: 0;
      left: 4px;
      border: 1px solid #FF3939;
      border-radius: 12px;
      width: 54px;
      height: 20px;
      font-size: 12px;
      text-align: center;
      color: #FF3939;
      background: rgba(255, 206, 206, .65);
    }
    //下方icon
    .icon-bt {
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      border-radius: 0 0 4px 4px;
      height: 22px;
      font-size: 12px;
      color: #FFFFFF;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      line-height: 22px;

      div {
        display: inline-block;
        overflow: hidden;
        margin: 2px 5px auto 30px;
        width: 77px;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .tag-list {
    >div {
      display: inline-block;
    }

    .tag-box {
      margin-right: 4px;
      padding: 2px 4px;
      font-size: 12px;
      text-align: center;
    }

    .tag-type-1 {
      border: 1px solid #FE3F3F;
      color: #FE3F3F;
    }

    .tag-type-2 {
      border: 1px solid #019491;
      color: #019491;
    }

    .tag-type-3 {
      border: 1px solid #06B266;
      color: #06B266;
    }

    .tag-release {
      border-radius: 2px;
      padding: 4px 0 4px 8px;
      width: 180px;
      height: 20px;
      font-size: 12px;
      color: #111A34;
      background: linear-gradient(294deg, rgba(249, 250, 251, 0) 0%, #F0F3F5 100%);
    }

    .red-release {
      background: linear-gradient(294deg, rgba(249, 250, 251, 0) 0%, #FFF1F0 100%);
    }
  }

  .gtag {
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 400;
    color: #666F83;
  }

  .mask {
    position: absolute;
    right: 0;
    bottom: 0;
    border-radius: 0 0 4px 4px;
    border-radius: 4px 0;
    width: 56px;
    height: 20px;
    font-size: 12px;
    text-align: center;
    color: #FFFFFF;
    background: rgba(15, 110, 233, .7);
    line-height: 20px;
  }
</style>
